import Phaser from "phaser";
import LoadingScene from "@/games/FishingTutorial-2/scenes/LoadingScene";
import QuestionScene from "@/games/FishingTutorial-2/scenes/QuestionScene";
import BeforeQuestionScene from "@/games/FishingTutorial-2/scenes/BeforeQuestionScene";
import AfterQuestionScene from "@/games/FishingTutorial-2/scenes/AfterQuestionScene";
import BossScene from "@/games/FishingTutorial-2/scenes/BossScene";
import LandingScene from "@/games/FishingTutorial-2/scenes/LandingScene";
import Settings from "@/games/FishingTutorial-2/scenes/Settings";

function launch(containerId) {
  return new Phaser.Game({
    type: Phaser.AUTO,
    backgroundColor: 0xf5f5f5,
    parent: containerId,
    scale: {
      parent: containerId,
      mode: Phaser.Scale.FIT,
      autoCenter: Phaser.Scale.CENTER_BOTH,
      width: 480,
      height: 854,
    },
    physics: {
      default: "arcade",
    },
    dom: {
      createContainer: true,
    },
    scene: [
      LoadingScene,
      QuestionScene,
      BeforeQuestionScene,
      AfterQuestionScene,
      BossScene,
      Settings,
      LandingScene,
    ],
  });
}

export default launch;
export { launch };
